// Delivery-mode filter options (v3 useDeliveryModeSelect gating: partner +
// feature flags). Extracted from MyAssessmentsFilters/LibraryFilters when the
// Overview page became the third consumer.
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { APMultiSelectOption } from '@/components/ap/form';
import { useEnabledFeatures } from '@/hooks/dataHelpers';
import { selectPartnerName, useCommonStore } from '@/store/commonStore';

export const useDeliveryModeOptions = (): APMultiSelectOption[] => {
  const { t } = useTranslation();
  const partnerName = useCommonStore(selectPartnerName);
  const enabledFeatures = useEnabledFeatures();

  return useMemo(() => {
    const options = [{ value: 'online', label: t('ExperienceListItem.browser') }];
    if (partnerName !== '21k') {
      options.push({
        value: 'online_secure',
        label: t('ExperienceListItem.browser_with_security'),
      });
      if (!enabledFeatures.disable_lockdown_mode) {
        options.push({ value: 'offline', label: t('ExperienceListItem.lockdown_app') });
      }
    }
    if (enabledFeatures.paper_mode) {
      options.push({ value: 'paper', label: t('ExperienceListItem.paper') });
    }
    return options;
  }, [partnerName, enabledFeatures.disable_lockdown_mode, enabledFeatures.paper_mode, t]);
};
